import dayjs from "dayjs"
import isSameOrAfter from "dayjs/plugin/isSameOrAfter"
import { camelCase, isString, mapKeys, upperFirst } from "lodash-es"
dayjs.extend(isSameOrAfter)

export function getId(obj) {
  try {
    if (obj && obj.id && parseInt(obj.id)) return parseInt(obj.id)
    if (parseInt(obj)) return parseInt(obj)
    return null
  } catch (err) {
    console.warn("Cannot Compute ID")
    return null
  }
}

export function getApolloId(obj) {
  try {
    if (obj && obj.__typename) {
      return `${obj.__typename}:${getId(obj)}`
    } else {
      return getId(obj)
    }
  } catch (err) {
    console.warn("Cannot Compute Apollo Id")
    return null
  }
}

export function clean(string) {
  try {
    if (isString(string)) {
      return string.replace(/\s/g, "")
    } else {
      return ""
    }
  } catch (err) {
    console.warn("Cannot clean the given string", string)
    return ""
  }
}

export function camelCaseShallow(obj) {
  return mapKeys(obj, (_, k) => camelCase(k))
}
export const rad = x => (x * Math.PI) / 180

export function getDistance(p1, p2) {
  if (p1 && p2 && p1.lat && p2.lat && p1.lng && p2.lng) {
    var R = 6378137 // Earth’s mean radius in meter
    var dLat = rad(p2.lat - p1.lat)
    var dLong = rad(p2.lng - p1.lng)
    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(rad(p1.lat)) *
        Math.cos(rad(p2.lat)) *
        Math.sin(dLong / 2) *
        Math.sin(dLong / 2)
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
    var d = R * c
    return d // returns the distance in meter
  }
  return null
}

export function readableDate(date) {
  try {
    return dayjs(date).format("ddd, Do MMM YYYY")
  } catch (e) {
    console.warn(e)
    return ""
  }
}

export function pascalCase(string) {
  return upperFirst(camelCase(string))
}

export function arrayToMap(arr, call = vs => vs) {
  return arr?.reduce?.((prev, vs) => {
    prev[vs.id] = call(vs)
    return prev
  }, {})
}

export function validKeys(obj) {
  try {
    return Object.keys(obj)
      .map(v => (parseInt(v) ? parseInt(v) : v))
      .filter(item => obj[item])
  } catch (err) {
    return []
  }
}

export function isFuture(date) {
  const today = dayjs().format("YYYY-MM-DD")
  const parsedDate = dayjs(date).format("YYYY-MM-DD")
  return dayjs(parsedDate).isSameOrAfter(today)
}

export function isPast(date) {
  const today = dayjs().format("YYYY-MM-DD")
  const parsedDate = dayjs(date).format("YYYY-MM-DD")
  return dayjs(parsedDate).isBefore(today)
}

export function getPosition(address) {
  try {
    if (address?.latitude && address?.longitude) {
      return {
        lat: address?.latitude,
        lng: address?.longitude,
      }
    } else {
      return null
    }
  } catch (error) {
    return null
  }
}

export function isUuid(uuid) {
  try {
    return /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(
      uuid
    )
  } catch (err) {
    return null
  }
}

export function generateId() {
  // Add a prefix to easily differenciate between server side and client side ids
  return `vt-${Date.now()}`
}

export function getName(item, items) {
  return items?.find?.(i => i?.id === item)?.name
}
/**
 *
 * @param {*} string The string to parse
 * @param {*} defaultValue The default value returned whenever the method throws an error
 */
export function parseJson(string, defaultValue = null) {
  if (!string) return defaultValue
  try {
    return JSON.parse(string)
  } catch {
    return defaultValue
  }
}
